  const subscriptionHandles = [
    'day-night-duo',
    'dreamy-melts',
    'kanna-wellness-bundle',
    'mary-jane-sampler',
    'simple-sunny-melts',
    'sunny-lovers',
    'sunny-melts',
    'sunny-trio',
    'super-sunny'
  ];

  function checkForSubscriptionProducts() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const hasValidSubscription = cart.items.some(item => {
          const isSubscription = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name;
          return (
            subscriptionHandles.includes(item.handle) &&
            isSubscription &&
            item.selling_plan_allocation.selling_plan.name.includes("Deliver Every")
          );
        });

        const subMsg = document.getElementById('subscription-message');
        const defaultFreeShipping = document.querySelector('free-shipping.free-shipping:not(#subscription-message free-shipping)');

        if (hasValidSubscription) {
          if (subMsg) subMsg.style.display = 'block';
          if (defaultFreeShipping) defaultFreeShipping.style.display = 'none';
        } else {
          if (subMsg) subMsg.style.display = 'none';
          if (defaultFreeShipping) defaultFreeShipping.style.display = 'block';
        }
      });
  }

  document.addEventListener('DOMContentLoaded', () => {
    checkForSubscriptionProducts();
    setInterval(checkForSubscriptionProducts, 1500);
  });
